export function labelTextColor(hex) {
  const c = (hex || "#000000").replace("#", "");
  if (c.length < 6) return "#ffffff";
  const r = parseInt(c.substr(0, 2), 16);
  const g = parseInt(c.substr(2, 2), 16);
  const b = parseInt(c.substr(4, 2), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.62 ? "#1e293b" : "#ffffff";
}
